import Rive from '@rive-app/react-canvas';

const Astronaut = () => (
    <Rive
        src="/assets/animations/astronaut.riv"
        animations="floating"
    />
);

export { Astronaut };